import { TRACE_STORE_NAME } from '@/creditflowresearch/application/Trace/constants';
import Range from '@/creditflowresearch/ui/common/components/organisms/Filters/FiltersPanel/Range/Range';
import { useTraceFiltersContext } from '@/creditflowresearch/application/Trace/TraceFilters/TraceFiltersContext';
import { useFiltersContext } from '@framework/ui/Organisms/Filters/FiltersContext';
import { toYearsFormatter } from '@/creditflowresearch/application/helpers';

const MaturityDateContainer = (props) => {
  const { getFiltersByFilterName } = useFiltersContext();
  const filters = getFiltersByFilterName(TRACE_STORE_NAME, props.filterName);
  const { itemsFilter } = useTraceFiltersContext();
  const { range: defaultRangeValue } = itemsFilter[props.filterName];

  const selectedRangeValue = {
    min: filters?.range.min,
    max: filters?.range.max,
  };
  const minValue = Number(toYearsFormatter(defaultRangeValue.min));
  const maxValue = Number(toYearsFormatter(defaultRangeValue.max));

  return <Range { ...props } selectedRangeValue={ selectedRangeValue } minValue={ minValue } maxValue={ maxValue } />;
};

export default MaturityDateContainer;
